import * as React from "react";
const DashboardAvatarIcon = (props) => (
  <svg
    width={23}
    height={21}
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.165 19.637c-1.623-2.736-4.125-4.698-7.045-5.628a7.54 7.54 0 0 0 3.194-3.636 7.306 7.306 0 0 0 .28-4.779 7.478 7.478 0 0 0-2.748-3.966A7.804 7.804 0 0 0 11.194.097c-1.68 0-3.315.538-4.651 1.53a7.478 7.478 0 0 0-2.749 3.967 7.307 7.307 0 0 0 .28 4.78 7.539 7.539 0 0 0 3.194 3.635c-2.92.929-5.421 2.89-7.045 5.628a.819.819 0 0 0 .3 1.155.869.869 0 0 0 1.177-.323c2.008-3.384 5.558-5.404 9.494-5.404 3.937 0 7.487 2.02 9.495 5.404a.837.837 0 0 0 .518.403.874.874 0 0 0 .658-.08.846.846 0 0 0 .4-.516.811.811 0 0 0-.1-.639ZM5.225 7.582c0-1.15.35-2.276 1.006-3.233A5.94 5.94 0 0 1 8.91 2.205a6.112 6.112 0 0 1 3.449-.33 6.019 6.019 0 0 1 3.056 1.592 5.777 5.777 0 0 1 1.634 2.98 5.684 5.684 0 0 1-.34 3.362 5.855 5.855 0 0 1-2.198 2.612 6.08 6.08 0 0 1-3.317.98 6.054 6.054 0 0 1-4.219-1.706 5.753 5.753 0 0 1-1.75-4.113Z"
      fill="currentColor"
    />
  </svg>
);
export default DashboardAvatarIcon;
